// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1___c47b18c78618307764e","cls2":"News-cls2___7b5b129cb77b4094fc9 News-cls1___c47b18c78618307764e"};